/**
 * The default identifier for the portal outlet.
 *
 * This constant is used as the default value for the portal outlet's ID,
 * ensuring a consistent reference throughout the application when no specific
 * portal ID is provided.
 */
export const DEFAULT_PORTAL_ID = 'default-portal-outlet';
